import React from 'react';
import {object, string} from 'prop-types';
import styled from "styled-components";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import { 
  getSizesStandart,
  getSizeScenario,
  getSelectedSize,
} from '../../selectors/entities/general';

import StandartSizeForm from "../FormStandartSize";

const FormWrap = styled.div`
    position: absolute;
    border: 1px solid #c4c4c4;
    max-width: 368px;
    border-radius: 4px;
    background-color: #f1f1f1;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1;

    @media (max-width: 768px) {
      max-width: 98%;
    }
`

class SelectStandartSize extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
    }
    this.formRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.formRef.current.contains(e.target)) {
      this.setState({ showForm: true });
    } else {
      this.setState({ showForm: false });
    }
  };

  onAfterMeasureSubmit = () => {
    this.setState({ showForm: false });
  }

  getSelectedSizes = () => {
    const { sizes, sizeScenario, sizeScenarioText } = this.props;

    if(sizeScenario === 'standart') {
      const {stdSize, height} = sizes;
      return `Воротник - ${stdSize || '?'}, Рост - ${height || '?'}`;
    } else if (['measure', 'smart', 'profile'].indexOf(sizeScenario) > -1) {
      const { displayName } = sizeScenarioText
      return displayName || '-';
    }
  }

  render() {

    let defaultText = 'Выбрать размер';
    if(this.props.sizeScenario) {
      defaultText = this.getSelectedSizes();
    }

    return (
      <div 
      className="b-rit-select b-rit-select__selection"
      ref={this.formRef}>
        {defaultText}
        {this.state.showForm && 
          <FormWrap>
            <StandartSizeForm 
              onAfterSubmit={this.onAfterMeasureSubmit}
              buttonSize={'full'}
              isCatalog={true}
            />
          </FormWrap>}
      </div>
    )
  }
}

SelectStandartSize.propTypes = {
  sizes: object.isRequired,
  sizeScenario: string,
  sizeScenarioText: object,
}

function mapStateToProps(state, ownProps) {
  return {
    sizes: getSizesStandart(state),
    sizeScenario: getSizeScenario(state),
    sizeScenarioText: getSelectedSize(state),
  }
}

export default connect(
  mapStateToProps, 
  null
)(withTranslation()(SelectStandartSize));